﻿import * as types from './mutation-types';
import * as addressService from '../../../api/addresslookup';
import basketService from '../../../api/basket';
import productService from '../../../api/products';
import checkoutService from '../../../api/checkout';


export const showAlert = ({ commit, state }, code) => {
    commit(types.SHOW_ALERT, code);
}

export const hideAlert = ({ commit, state }) => {
    commit(types.HIDE_ALERT);
}

export const updateAlert = ({ commit, state }, code) => {
	var newAlert = Object.assign({}, state.alertModal);
	newAlert.body = code.body || newAlert.body;
	if (code.header == "") {
		// empty string means we want the header cleared
		newAlert.header = "";
	}
    newAlert.options = code.options || newAlert.options;
    commit(types.UPDATE_ALERT, newAlert);
}

export const isBadPayer = ({ commit, state }, code) => {
    commit(types.IS_BAD_PAYER, code.isBadPayer);
    commit(types.SHOW_ALERT, code);
}

export const registerBasket = ({ commit, state }, block) => {
    commit(types.REGISTER_BASKET, block.id);
    
    basketService.getBasket(
    block.id,
    (res) => commit(types.UPDATE_BASKET, res.basketView),
    (res) => console.log(res)
    );
}

export const updateBasket = ({ commit, state }) => {
    basketService.getBasket(
        state.basket.id,
        (res) => commit(types.UPDATE_BASKET, res.basketView),
        (res) => console.log(res)
    );
}

export const updateValidState = ({ commit, state }, formState) => {
    var blockAllreadyInState = false;
    var existingBlocks = state.form;
    if (existingBlocks) {
        for(var i = 0; i < existingBlocks.length; i++){
            if (existingBlocks[i].blockId == formState.blockId) {
                formState.index = i;
                commit(types.VALIDATE_FORM_BLOCK, formState);
                blockAllreadyInState = true;
                break;
            }
        }
    }
    if (!blockAllreadyInState) {
        commit(types.REGISTER_FORM_BLOCK, formState);
    }
} 

export const updateCustomer = ({ commit, state }, customer) => {

    var newCustomerData = Object.assign({}, state.customer); 

    newCustomerData.firstName = customer.firstName || newCustomerData.firstName;
    newCustomerData.lastName = customer.surname || newCustomerData.lastName;
    newCustomerData.street = customer.address.urbanAddress.streetName || newCustomerData.street;
    newCustomerData.houseNumber = customer.address.urbanAddress.streetNr || newCustomerData.houseNumber;
    newCustomerData.houseLetter = customer.address.urbanAddress.streetNrSuffix || newCustomerData.houseLetter;
    newCustomerData.floor = customer.address.urbanAddress.floorNumber || newCustomerData.floor;
    newCustomerData.door = customer.address.urbanAddress.doorNumber || newCustomerData.door;
    newCustomerData.zipCode = customer.address.urbanAddress.postcode || newCustomerData.zipCode;
    newCustomerData.city = customer.address.urbanAddress.city || newCustomerData.city;

    newCustomerData.cprNumber = customer.idnumber || newCustomerData.cprNumber;
    newCustomerData.email = customer.emailAddress || newCustomerData.email;
    newCustomerData.emailConfirmed = customer.emailAddress || newCustomerData.emailConfirmed;
    newCustomerData.mobilePhone = customer.telephoneNumber.localNumber || newCustomer.mobilePhone;
    
    
    commit(types.UPDATE_CUSTOMER, newCustomerData);
}

export const updateCustomerFromDebitorData = ({ commit, state }, customer ) => {

    var newCustomerData = Object.assign({}, state.customer); 

    newCustomerData.firstName = customer.firstAndMiddleName || newCustomerData.firstName;
    newCustomerData.lastName = customer.lastName || newCustomerData.lastName;
    newCustomerData.street = customer.streetName || newCustomerData.street;
    newCustomerData.houseNumber = customer.houseNumber || newCustomerData.houseNumber;
    newCustomerData.houseLetter = newCustomerData.houseLetter;
    newCustomerData.floor = customer.floor || newCustomerData.floor;
    newCustomerData.door = customer.door || newCustomerData.door;
    newCustomerData.zipCode = customer.zip || newCustomerData.zipCode;
    newCustomerData.city = customer.city || newCustomerData.city;

    commit(types.UPDATE_CUSTOMER, newCustomerData);

};

export const existingCustomerBlockActive = ({ commit }, bool) => {
    commit(types.EXISTING_CUSTOMER_BLOCK_ACTIVE, bool);
};

export const validateCustomerData = ({ commit }, bool) => {
    commit(types.VALIDATE_CUSTOMER_DATA, bool);
};

export const existingCustomer = ({ commit }, bool) =>{
    commit(types.IS_EXISTING_CUSTOMER, bool);
};